var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.color,attrs:{"dark":""}},[_c('v-card-text',{staticClass:"text-center",staticStyle:{"height":"80px"}},[_c('p',[_c('small',{staticClass:"font-weight-thin",staticStyle:{"border-bottom":"1px solid #F96332"}},[_vm._v(_vm._s(_vm.label))]),_c('br'),_c('span',{staticClass:"lg-font"},[_vm._v(_vm._s(_vm.data))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }